export const languageMap = {
  'English (US)': 'en_US',
  Spanish: 'es',
  French: 'fr',
  German: 'de',
  Hindi: 'hi',
  Gujarati: 'gu',
};

export function fileToRawBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || '');
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

function mapButtons(buttons) {
  return (buttons || []).map((btn) => ({
    type: btn.type,
    text: btn.text,
    value: btn.type === 'quick_reply' ? '' : btn.value,
  }));
}

export function buildCreateTemplatePayload(formState) {
  const {
    templateType,
    templateName,
    language,
    category,
    headerType,
    headerText,
    bodyText,
    footerText,
    buttons,
    cards,
    cardHeaderType,
    otpType,
    securityRecommendation,
    expiryWarning,
    expiryMinutes,
    authButtonText,
    androidPackageName,
    appSignatureHash,
    autofillButtonText,
  } = formState;

  const languageCode = languageMap[language] || 'en_US';

  if (category === 'Authentication') {
    const payload = {
      template_name: templateName,
      language: languageCode,
      category: 'AUTHENTICATION',
      header_type: 'NONE',
      otp_type:
        {
          'Copy Code': 'COPY_CODE',
          'One Tap Autofill': 'ONE_TAP',
          'Zero Tap': 'ZERO_TAP',
        }[otpType] || 'COPY_CODE',
      add_security_recommendation: securityRecommendation,
      auth_button_text: authButtonText,
    };

    if (expiryWarning && expiryMinutes) {
      payload.code_expiration_minutes = parseInt(expiryMinutes, 10);
    }

    if (otpType === 'One Tap Autofill') {
      payload.supported_apps = [
        {
          package_name: androidPackageName,
          signature_hash: appSignatureHash,
        },
      ];
      payload.autofill_button_text = autofillButtonText;
    } else if (otpType === 'Zero Tap') {
      delete payload.auth_button_text; // Zero tap has no buttons
    }

    return payload;
  }

  if (templateType === 'Carousel') {
    const header_type = (cardHeaderType || 'IMAGE').toUpperCase();
    return {
      template_name: templateName,
      template_type: 'CAROUSEL',
      category: 'MARKETING',
      language: languageCode,
      body_text: bodyText,
      variable_samples: {},
      cards: (cards || []).map((card) => {
        const mapped = {
          header_type,
          body_text: card.body_text || '',
          variable_samples: {},
          buttons: mapButtons(card.buttons),
        };
        if (header_type === 'VIDEO') {
          mapped.video_base64 = card.video_base64 || '';
        } else {
          mapped.image_base64 = card.image_base64 || '';
        }
        return mapped;
      }),
    };
  }

  return {
    template_name: templateName,
    language: languageCode,
    category: category.toUpperCase(),
    header_type: headerType.toUpperCase(),
    header_text: headerType === 'Text' ? headerText : '',
    body_text: bodyText,
    footer_text: footerText || '',
    include_call_button: buttons.length > 0,
    button_text: buttons.length > 0 ? buttons[0].text : '',
    buttons: mapButtons(buttons),
    variable_samples: {},
  };
}
